/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Timeline_Zoom_OutInputs */



/**
* | output |
* | --- |
* | "Zoom out on the Timeline" |
*
* @param {Shortcut_Keys_Desc_Timeline_Zoom_OutInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_timeline_zoom_out = /** @type {((inputs?: Shortcut_Keys_Desc_Timeline_Zoom_OutInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Timeline_Zoom_OutInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dezoomer sur la timeline")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitleiste herauszoomen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riduci lo zoom sulla linea temporale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отдалите масштаб временной шкалы.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alejar la línea de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("缩小时间线")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムラインをズームアウトする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमलाइन पर ज़ूम आउट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Diminua o zoom na Linha do Tempo")
	return /** @type {LocalizedString} */ ("Zoom out on the Timeline")
});